import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4 bg-white" data-id="element-38">
      <div className="max-w-3xl mx-auto" data-id="element-39">
        <div className="border-4 border-dashed border-gray-300 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8" data-id="element-40">
          <div className="flex-shrink-0" data-id="element-41">
            <ShieldCheck className="w-24 h-24 text-blue-600" data-id="element-42" />
          </div>
          <div className="text-center md:text-left" data-id="element-43">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-44">
              🔒 Garantía sin riesgo
            </h2>
            <p className="text-lg text-gray-700 mb-4" data-id="element-45">
              Probalo durante 7 días. Si no sentís más claridad, contención y
              descanso, te devolvemos el 100% del dinero.
            </p>
            <p className="font-bold text-gray-900" data-id="element-46">Sin preguntas.</p>
          </div>
        </div>
      </div>
    </section>;
}